import { ITypeTicketData } from 'meta/pages/v4/typeticket'

export type TypeTicketState = {
  typetickets: Record<string, ITypeTicketData>
}

export const initialState: TypeTicketState = {
  typetickets: {},
}
